<template>
  <div>
    <main-toolbar></main-toolbar>
    <v-layout row justify-center class="hidden-sm-and-down" v-if="!isLoading">
    <v-card class="surfAndScanborder"  style="min-width: 50%;">
        <v-card-text class="display-1 font-weight-bold abstandObenklein"
        >
          Wie soll die Datei heißen?
        </v-card-text>

        <v-layout row wrap justify-center abstandcardunten abstandOben>
          <v-flex row d-flex xs12 sm12 md6 fluid>
            <v-text-field
              solo
              v-model="fileName"
              @keyup.enter="setFileName()"
              label="Dateiname"
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center abstandcardunten abstandOben>
          <v-flex row d-flex xs12 sm12 md6 fluid>
            <v-select
              :items="categories"
              v-model="selectedCategories"
              item-text="title"
              item-value="guid"
              clearable
              multiple
              label="Kategorie"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center abstandcardunten>
          <v-flex row d-flex xs12 sm12 md6 fluid justify-center class="">
            <v-btn small color="primary" @click="backPage()">Zurück</v-btn>
            <v-btn small color="text-white" class="surfAndScanColor" @click="setFileName()">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <!-- Ende Seite 3 -->
  </v-layout>
  </div>
</template>

<script>
import Vue from 'vue'
import MainToolbar from './../toolbar/MainToolbar'
export default {
  components: {MainToolbar},
  name: 'page03',
  data () {
    return {
      value: 0,
      fileName: '',
      scanParameter: {},
      categories: [],
      scanStarted: false,
      selectedCategories: [],
      items: [
        {
          active: false,
          title: 'Was möchten Sie scannen?',
          subtitle: 'Mehrere Seiten'
        },
        {
          active: false,
          title: 'Einseitig oder Beidseitig?',
          subtitle: 'Beidseitig'
        },
        {
          active: true,
          title: 'Ihre Datei heißt:',
          subtitle: ''
        },
        {
          active: false,
          title: 'Herunterladen',
          subtitle: ''
        }
      ]
    }
  },
  methods: {
    backPage: function () {
      this.$router.push('/page2')
    },
    setFileName: function () {
      var fileName = this.fileName
      console.log('selectedCategories', this.selectedCategories)
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'categories',
        value: this.selectedCategories
      })
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'fileNamePattern',
        value: fileName
      })
      this.$router.push('page4')
    },
    onGetConfig: function (config) {
      console.log('onGetConfig', config)
    },
    onGetCategories: function (data) {
      console.log('onGetCategories', data)
      this.categories = data.categories
    },
    multiPage: function () {
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'duplex',
        value: true
      })
      this.$router.push('page4')
    }
  },
  mounted () {
    this.scanParameter = Vue.prototype.scanApi.getScanParameter()
    this.fileName = this.scanParameter.fileNamePattern
    Vue.prototype.scanApi.getCategories(this.onGetCategories)
    Vue.prototype.scanApi.getConfig(this.onGetConfig)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Page03.vue